import { DATA_REQUEST_ASYNC, DATA_UPDATE_REQUEST_ASYNC, VERIFY_DOMAIN_ASYNC } from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const updateData = () => ({ type: DATA_UPDATE_REQUEST_ASYNC.INITIATE })
export const updateDataSuccess = () => ({
  type: DATA_UPDATE_REQUEST_ASYNC.SUCCESS,
})
export const updateDataError = (error) => ({
  type: DATA_UPDATE_REQUEST_ASYNC.ERROR,
  error,
})
export const updateDataCancel = () => ({
  type: DATA_UPDATE_REQUEST_ASYNC.CANCEL,
})

const verifyDomain = (mailerDomain) => ({
  type: VERIFY_DOMAIN_ASYNC.INITIATE,
  payload: { mailerDomain },
})
export const verifyDomainSuccess = () => ({ type: VERIFY_DOMAIN_ASYNC.SUCCESS })
export const verifyDomainError = (error) => ({
  type: VERIFY_DOMAIN_ASYNC.ERROR,
  error,
})
const verifyDomainCancel = () => ({ type: VERIFY_DOMAIN_ASYNC.CANCEL })

export default {
  // to props
  fetchData,
  fetchDataCancel,
  updateData,
  updateDataCancel,
  verifyDomain,
  verifyDomainCancel,
}
